<template>
    <v-dialog v-model="internalModel" max-width="500" persistent>
        <v-card>
            <v-card-title class="error-title">
                <v-row class="justify-center py-2">
                    <v-icon class="mr-4" color="white">
                        mdi-alert-circle-outline
                    </v-icon>
                    Sessão expirada
                </v-row>
            </v-card-title>
            <v-card-text class="py-4">
                <div class="d-flex flex-row justify-center">
                    <h4>Sua sessão expirou. Por favor, faça login novamente.</h4>
                </div>
            </v-card-text>
            <v-card-actions class="justify-center">
                <v-btn color="error" plain @click="redirectToLogin">OK</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "SessionExpiredDialog",
    props: {
        model: { type: Boolean, required: true }, // Add model prop
    },
    emits: ['update:model'], // Emit event for v-model
    computed: {
        internalModel: {
            get() {
                return this.model;
            },
            set(value) {
                this.$emit('update:model', value); // Emit changes to parent
            }
        }
    },
    methods: {
        redirectToLogin() {
            this.$emit('update:model', false); // Close dialog
            window.location.href = '/login';
        }
    }
}
</script>

<style scoped>
.error-title {
    background-color: #f44336;
    color: #FFF;
    width: 100%;
}
</style>
